/* Bandhoo blog content from the approved design (blog-data.jsx).
   Source: Prashant Gupta LinkedIn activity, scraped 30 Jun 2026.
   64 posts (latest first) and 4 long-form articles. */

export const blogPosts = [
    {
        "num": 1,
        "date": "28 Jun 2026",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "We see thousands of ConstructionWorker registrations every month on our Bandhoo Solutions mobile App. In 2020-21, the wages for Helpers and Masons for 8-hour duty would roughly be Rs 350 and Rs 550 (obviously, metro markets were more expensive).",
            "Look at the last 3 months of registrations data - and the wage expectations of workers by each skill. The climb over the last 5 years has been sharp - much higher than regular inflation numbers. This growth will continue unabated in the coming decade or so. Construction projects span multiple years and Asset owners/ Developers and GeneralContractors and CostConsultants need to take this into account, and also plan to offer higher rates if they want to complete their projects on-time.",
            "PS - This is average across India. Metro markets are higher by Rs 150-200"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7476995924347510784/"
    },
    {
        "num": 2,
        "date": "17 Jun 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Finally Construction might see infusion of good talent. Better outcomes ahead, surely."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7472842533493035009/"
    },
    {
        "num": 3,
        "date": "09 Jun 2026",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "ConTech",
            "ConstructionTechnology",
            "AI",
            "ProjectManagement",
            "Procurement",
            "ConstructionManpower"
        ],
        "paras": [
            "McKinsey taught me one very important lesson. In the B2B world, your client list is what drives your reputation and growth momentum.",
            "And I am so lucky... to be able to claim that Bandhoo Solutions has all the biggest names in Real Estate as its clients - Lodha, Godrej, Oberoi, Prestige, Brigade, Embassy, Birla, Signature, L&T Realty, Runwal, Marathon, Gera, RMZ, myHomes, JLL, Savills, Shriram, and many more. Basically, almost all the large ones except DLF.",
            "So if you are in RealEstate / Construction in India, looking to achieve operational excellence or digital transformation, then talk to us. Learn from the best in the business to scale newer heights."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7469985139603742720/"
    },
    {
        "num": 4,
        "date": "29 May 2026",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "CONSTRA for visual monitoring of progress, safety and quality of construction sites is getting traction with early adopters of ConstructionTechnology. SignatureGlobal is one such company. Saurabh Jolly has led this initiative at SGIL under the guidance of its Promoters (Lalitji and Nikhil). The deployment of CONSTRA across all of their projects has been very fast and smooth. Glad to be partnering with SGIL on their journey of building an iconic brand and business using cutting-edge technology solutions."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7465991028685078528/"
    },
    {
        "num": 5,
        "date": "27 May 2026",
        "repost": false,
        "topic": "Company",
        "tags": [
            "Construction",
            "ArtificialIntelligence",
            "GeneralContractors"
        ],
        "paras": [
            "Mumbai based RealEstate Developers are the fastest adopters of Technology. Maybe because many of them are also Pan-India players and operate at a bigger scale.",
            "Our Saas Revenues (at Bandhoo Solutions) are split as follows - about 70% from Mumbai based clients, 15% from Bangalore based clients, and 10% from NCR.",
            "What's your experience in ConstructionTechnology across Indian metros? Please share in comments."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7465348507072135168/"
    },
    {
        "num": 6,
        "date": "19 May 2026",
        "repost": false,
        "topic": "Careers",
        "tags": [
            "PMC",
            "ProjectManagement",
            "Construction",
            "RealEstate",
            "Leadership",
            "SeniorManagement",
            "DesignAndBuild"
        ],
        "paras": [
            "Bandhoo Solutions is looking to add a young, dynamic, P&L leader to our core leadership team.",
            "12-15 years of experience in pitching to Industrial/Office clients and managing Construction Projects (fitouts or civil or any other variety). Compensation will be competitive. Engineer. MBA is a plus but not mandatory. Fire-in-the-belly, Technology orientation, and hustle mindset is the main ask.",
            "Write to me directly. Please tag those in your network who might be a good fit. Location could be Bangalore or NCR."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7462365145516625921/"
    },
    {
        "num": 7,
        "date": "30 Apr 2026",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "FY26 has been very strong for Bandhoo Solutions",
            "1. Operating Revenues were up 50% YOY to reach Rs 25+cr",
            "2. Gross Profit doubled to Rs 12 cr approximately",
            "3. EBITDA profit at Rs 3cr (12% margin) has been a good turnaround from loss last year",
            "4. We continue to add new marquee logos as clients - Oberoi Realty, Signature Global, Shriram Properties, Runwal Enterprises, Leighton, Assetz Group being the notable ones",
            "Most importantly, all our three businesses have now achieved PMF. In each of them we now have a solid product/ service whose value proposition has been sharpened through multiple iterations with Large Enterprise clients. There is solid pull/demand for each of them that will hopefully give us the tailwinds in the coming years for exponential growth in a profitable manner."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7455541833025212417/"
    },
    {
        "num": 8,
        "date": "28 Apr 2026",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "The 15% Rule: Why Your Construction Project Needs a Payroll 'Core' RealEstate Construction ConstructionManpower ProjectManagement AvoidingDelays CostManagement",
            "Bandhoo Solutions | Gaurav Jajodia"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7454826982241927168/"
    },
    {
        "num": 9,
        "date": "26 Apr 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "VisualMonitoring of construction sites will become the norm. Developed world is going to use robots and Indian sites will use humans (for some time) to capture data and run the analytics.",
            "Transformative change to ensure accurate data is available to all decision makers.",
            "Bandhoo Solutions offers this to clients who are early adopters of modern technology."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7453980332682502144/"
    },
    {
        "num": 10,
        "date": "24 Apr 2026",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "Construction",
            "RealEstate",
            "Infrastructure",
            "ConstructionTechnology"
        ],
        "paras": [
            "Billings related problems in Indian Construction sector can be solved by clients (i.e., Asset Owners and General Contractors) quite easily. The impact is tremendous and unmistakable. Bandhoo Solutions' PLM offers this functionality (among other things) handling all possible scenarios. Easy to deploy and adopt."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7453324513062203392/"
    },
    {
        "num": 11,
        "date": "23 Apr 2026",
        "repost": false,
        "topic": "Manpower",
        "tags": [
            "Infrastructure"
        ],
        "paras": [
            "Construction costs rise every year due to minimum wages revisions by each State Government. AND THESE CAN BE SIGNIFICANT. Look at the announcement by the Haryana Government. The table is as below and increase is 30-40%. In the next 5 years, it is quite likely that the labour cost contribution to Capex Cost of a project will be 40-50%.",
            "Companies (Asset owners and Contractors) need to factor this in carefully whenever undertaking works that span two or more FYs as these announcements happen in April.",
            "Bandhoo Solutions | ConstructionWorkers | GeneralContractors | RealEstate |"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7453115660450103296/"
    },
    {
        "num": 12,
        "date": "23 Apr 2026",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "CONSTRA works well as a progress, quality and safety monitoring solution primarily because it requires minimal data-entry by the site teams, and instead it provides 100% accurate visual data to all decision-makers in a timely manner. Oberoi Realty CIO - Pankaj Pandit - has been an early adopter.",
            "Check out his thoughts in this video -",
            "Bandhoo Solutions' CONSTRA is being used by many companies across Real Estate, PMC, and General Contractors - Signature Global, Marathon Realty, Shriram Properties, Brigade, Swadeshi Infra, Assetz Properties, Suncity, K2K/ Prestige, etc."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7453029598591881216/"
    },
    {
        "num": 13,
        "date": "09 Apr 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Construction World",
            "Pranjal Patil",
            "Thanks CW for the opportunity to share our journey, our solutions, and the outlook"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7447990241610665984/"
    },
    {
        "num": 14,
        "date": "08 Apr 2026",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [
            "QualityControl",
            "QualityAssurance",
            "Construction",
            "ConstructionTechnology",
            "CONSTRA"
        ],
        "paras": [
            "Can AI really solve QC for residential projects? This topic is a hot one with varied and generally controversial views. Let me try to demystify this and provide a more structured POV. As always with complex issues, the answer is not a straight Yes/No and more nuanced:",
            "1. Some defects cannot be identified through analyzing visuals (photos/ videos) - so that itself rules out a certain class of defects that have to be manually assessed at the site, sometimes using specialized equipment",
            "2. Some defects are visual in nature but too minute for AI-based analytics of captured photos/ videos. A human at site who can look at things more closely is the only way to identify and tag those.",
            "3. So that leaves a whole class of defects that are visually identifiable through an AI-Agent processing visuals. More often than not, this list itself is quite long and it takes a QC engineer quite some time to mark/tag those. Given repetitive nature, this is also where fatigue leads to misses.",
            "THIS THIRD SEGMENT IS WHERE AI CAN REALLY PROVIDE ACCURACY AND SPEED. There are surely benefits from enabling a QC engineer with AI-enabled analytics. But it is important for leaders in Real Estate and Construction to realize what those are and how to capture them without taking any undue risks.",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7447566117277028352/"
    },
    {
        "num": 15,
        "date": "03 Apr 2026",
        "repost": true,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "2 million workers needed. Zero time to fix it.",
            "India’s construction engine is scaling—but the skill gap, execution delays, and efficiency leaks are widening fast.",
            "Featuring exclusive interviews with:",
            "Dhaval Ajmera, Director – Corporate Affairs, Ajmera Group, Ajmera Realty & Infra India Ltd.",
            "Rajesh Kumar Singh, CEO, Jyoti Structures Limited",
            "Prashant Gupta, Founder & CEO, Bandhoo Solutions",
            "Plus: Smart homes, HVAC strategy, large impact projects AND A LOT MORE!",
            "🔗 Read now: www.constructionworld.in IMPACCT.info Infrastructure Today Magazine",
            "Pranjal Patil Sami S. Kavita Parab Tanveer Padode Pratap Padode Falguni Padode"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7445689370885394432/"
    },
    {
        "num": 16,
        "date": "06 Mar 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [
            "Realestate",
            "constructionTech"
        ],
        "paras": [
            "8 of the Top 10 listed here are our clients at Bandhoo Solutions",
            "Hopefully we will increase this to 15 out of 15 in the coming years."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7435613719772049409/"
    },
    {
        "num": 17,
        "date": "04 Mar 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Interesting insight that has ramifications for all participants in the Construction ecosystem in India. Capabilities have to evolve and scale up in so many different companies for this transition."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7434840185160359936/"
    },
    {
        "num": 18,
        "date": "04 Mar 2026",
        "repost": false,
        "topic": "Company",
        "tags": [
            "Growth",
            "Acquisitions",
            "RealEstate",
            "Infrastructure",
            "GeneralContractors",
            "Construction"
        ],
        "paras": [
            "If you are a ConstructionTechnology entrepreneur with a Saas product that has 5+ paying customers, and you are open to be acquired, then please DM me (or email me on prashant dot gupta at bandhoo dot com). We have done two Saas acquisitions in the last 4 years and created great value for all stakeholders. We are now open to do more of the same.",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7434824768203239425/"
    },
    {
        "num": 19,
        "date": "02 Mar 2026",
        "repost": true,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Building AI products for construction presents unique challenges, and surprisingly, the toughest part isn't the technology itself.",
            "It is earning the trust of a senior project director over his instincts.",
            "Here are two key lessons I learned at CONSTRA (acquired by Bandhoo):",
            "1. If senior stakeholders don't perceive the value, the AI effectively doesn't exist.",
            "We had a client diligently capturing data, yet management never logged in. Instead of waiting, we began sending bite-sized progress reports directly to their WhatsApp. Within weeks, those who previously had no time for onboarding were requesting more updates.",
            "The AI remained unchanged; what shifted was the visibility.",
            "2. Don't focus solely on price; make the outcome undeniable.",
            "When a client hesitated over costs, we proposed a 3-month pilot with clearly defined success criteria. By the end of the pilot, we achieved a 50% reduction in site visits, reduced snag resolution time from weeks to days, and significantly improved contractor billing accuracy. This led to an immediate expansion to all ongoing projects at full price.",
            "These insights are integral to our approach at VinMeAi. We develop AI solutions - knowledge assistants, design automation, and agentic workflows - for businesses committed to transformation. Our primary focus is on customer success.",
            "We prioritize actual, measurable changes in our clients' operations over mere deployment or go-live.",
            "The reality is that AI that remains unused is simply expensive software.",
            "The takeaway:",
            "AI succeeds not by being smart, but by being impossible to ignore."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7434184452693565440/"
    },
    {
        "num": 20,
        "date": "23 Feb 2026",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Good read. Covers some of the important points that asset owners and Contractors should think deeply about."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7431506778573422592/"
    },
    {
        "num": 21,
        "date": "22 Feb 2026",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "We had our company-wide offsite on Friday and Saturday. Since most of our employees work-from-home, this was an opportunity to connect with everyone, get to know them better, and also discuss our future plans. This is our 4th offsite in 6 years and thankfully we have consistently grown in size every time.",
            "Highlight - We got Srinivasa Addepalli (GlobalGyan Leadership Academy) to do a very important \"Learning to Learn\" session, which is one of the most important skills to build in our rapidly evolving world. Thanks to Kissan for doing this on a Saturday afternoon.",
            "Memorable - We got Hudaiba Pandit to join us this time with her 2-year old son and spend some informal time with everyone.",
            "Bandhoo Solutions Sridhar Sundaram"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7431194364321693696/"
    },
    {
        "num": 22,
        "date": "01 Feb 2026",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Bandhoo Solutions turns 6 today - we went live on 1st February 2020.",
            "Given how much of a roller-coaster this ride has been, I thought of sharing a note of gratitude for some of the most important people who have helped us get to where we are.",
            "1)    Srikrishna Ramamoorthy from Unitus, who called me in March 2021 and shared our first termsheet. That termsheet gave us a new lease of life when we were on the brink of despair and shutdown (thanks to Covid 1 and 2). And Surya Mantha, who has been an active supporter for us ever since.",
            "2) Prashant Malik, Manish Gupta, Neeraj Aggarwal, Srini Sriniwasan, and Vikram Kapur – who all contributed large chunks of angel money based on my one phone call to them – no questions asked",
            "3)    Shyam Menon of BIF and Kitty Agarwal of InfoEdge Ventures who topped up the round to make it meaningful, which in turn allowed us to make our first all-cash Saas acquisition in Dec 2021",
            "4)    Abhishek Lodha who bet on us in mid-2022 when we were not-so-well-known as a provider for a mission-critical Saas offering (Project Lifecycle Cost Manager)",
            "5)    Rajesh Agarwal and Rohit Supekar (and now Umacharan ji) of Lodha who have been awesome partners – listening to us, pushing us, helping us – in true partnership format. At nearly 1000 user licenses, PLM implementation at Lodha is by far the biggest implementation of any Saas product in Indian Real Estate.",
            "6)    Vikas Singhal and Binit (both are ex-Godrej Properties) who were bold enough to try out our construction manpower staffing model at scale",
            "7) Abhishek Kumar (ex-Emaar, ex-abof) who has been helping in myriad ways, including a formal capital contribution in our last Pre-Series-A round",
            "8)    Pankaj Pandit of Oberoi Realty who has wholeheartedly pushed the adoption of CONSTRA within their project operations in a meaningful way",
            "Special thanks to Manish Gupta, my brother-in-law, who has been an inspiration in terms of showing how you build a solid business over decades.",
            "To expand beyond these named individuals, all of our clients (except the few who have given us a lot of payment troubles) deserve our gratitude. Thanks is also due to all of our employees (current and former) who have been part of our journey, and who have made Bandhoo what it is today.",
            "We are serving (or have served) almost all of the biggest names in Real Estate and Construction in India (e.g., Lodha, Godrej, Oberoi, Birla, Emaar, Embassy, Brigade, Prestige, Sobha, RMZ, Signature Global, Gera, Piramal, Runwal, L&T, L&T Realty, Tata Projects, and many more). Nobody else in ConstructionTechnology comes close.",
            "With continued efforts, and some luck, we will have built something really distinctive by the time we reach our 10-year anniversary.",
            "Sridhar Sundaram"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7423538373803311105/"
    },
    {
        "num": 23,
        "date": "06 Jan 2026",
        "repost": false,
        "topic": "PLM",
        "tags": [],
        "paras": [
            "Thanks to CA. Nikhil Aggarwal who has given us the opportunity to deploy our PLM (Project Lifecycle cost Manager) solution at Signature Global",
            "Kicked off the program today. Aptly called PROPEL - Program for Operations Excellence - that will support SGIL in its hyper-growth journey over the coming years.",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7414282814587584512/"
    },
    {
        "num": 24,
        "date": "02 Jan 2026",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Like every year since 2020, 2025 was also a year where we grew Bandhoo Solutions steadily on all the key metrics -",
            "1) Revenues are up 40%",
            "2) Hired 40 new employees",
            "3) Added several new client logos (e.g., Oberoi, Signature Global, Adani, RMZ, Isprava)",
            "4) Became profitable in Feb and have stayed profitable thereafter",
            "Nothing dramatic - the tortoise continues to make slow but steady progress.",
            "Looking forward to an even better 2026 - creating tremendous value for all our stakeholders - customers, employees, and investors."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7412714784007086080/"
    },
    {
        "num": 25,
        "date": "15 Dec 2025",
        "repost": false,
        "topic": "Manpower",
        "tags": [
            "Civil",
            "MEP",
            "Finishing."
        ],
        "paras": [
            "Monthly Site Overhead Costs: Rs 10-15 lakhs",
            "This makes delays very expensive. Nowadays, construction project delays are almost always due to constructionmanpower shortages. So project owners need to find modern ways of finding additional manpower for avoiding such expensive delays.",
            "Bandhoo Solutions can help. We have access to skilled workers of all kinds across India."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7406196258467536896/"
    },
    {
        "num": 26,
        "date": "06 Jul 2025",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Met my dear friend AmitLodha in Patna yesterday. He is such an authentic and lovable person. We relived some of our hostel days at IITD.",
            "He enthralled me with his roller coaster life experiences as an upright IPS officer. One can spend days listening to him.",
            "His recent fiction book - Police Affairs - is going great guns. I wish him great success and fortune, always."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7347521825200852992/"
    },
    {
        "num": 27,
        "date": "29 Jun 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "Procurement",
            "Construction",
            "ConstructionWorkers",
            "Bandhoo",
            "ConstructionTechnology"
        ],
        "paras": [
            "On similar lines as the very-successful-and-iconic Mastercard's \"Priceless\" ad -",
            "Time taken for a client to register Bandhoo as a vendor: 1-2 weeks",
            "Time taken for a client to issue a proper WO: 3-6 weeks",
            "Expectation of time taken to mobilize construction workers at their project site: 1 week",
            ":-)",
            "This always make me smile. Always!",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7344955007579930624/"
    },
    {
        "num": 28,
        "date": "14 Jun 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "RealEstate",
            "Procurement",
            "Contracting",
            "CostManagement",
            "RABillings",
            "ContractManagement"
        ],
        "paras": [
            "An amazing feeling of tremendous satisfaction, even delight --- when your client derives multifold ROI from your Saas solution. Particularly after strong resistance to adoption for several months.",
            "Has happened with two of our clients in this quarter.",
            "Fingers crossed for more of the same!!",
            "Bandhoo Solutions, Nikhilesh Dangayach, Sridhar Sundaram, Noopur Arora, Gaurav Jajodia and Sumanth."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7339688791302934528/"
    },
    {
        "num": 29,
        "date": "03 Jun 2025",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [
            "ScanToBIM",
            "RealEstate",
            "ConstructionTechnology"
        ],
        "paras": [
            "Scan to BIM as a service",
            "This has come up a couple of times in our client discussions. It is a valuable service for those buildings/ infrastructure where you don't have BIM models or suitable documentation. It is a very expensive service that is relevant for heritage conservation sites, or older buildings where facility management needs more information for RCA of issues being faced. Also, the building needs to be scanned only once. If you are thinking of doing this repeatedly (like once or twice a month), it is probably inadvisable.",
            "Summary of my thoughts in this blog - [link]"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7335608258335789056/"
    },
    {
        "num": 30,
        "date": "01 Jun 2025",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "I asked Perplexity to summarize the comparison between CONSTRA of Bandhoo Solutions, OpenSpace and Observance.ai. I have published this verbatim as a blogpost on Medium. I must say I was quite impressed with the quality of the output from Perplexity.",
            "Please have a read, particularly if you are a RealEstate or Construction professional."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7334815991148748800/"
    },
    {
        "num": 31,
        "date": "28 May 2025",
        "repost": false,
        "topic": "Industry",
        "tags": [],
        "paras": [
            "Very interesting debate about this Free POC topic.",
            "Our experience at Bandhoo Solutions is that it is advisable to do a low-cost POC (not Free) so that the commitment from client is also strong in terms of providing feedback and ideas based on usage.",
            "Obviously, if you are very early stage in your product, it is unlikely that a customer will pay you for trying it out. They are helping you improve your product.",
            "Indian realestate and Construction companies are definitely becoming more keen to adopt technology now than 3 years back. We can see it in our discussions and pipeline."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7333292726383255552/"
    },
    {
        "num": 32,
        "date": "13 May 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [],
        "paras": [
            "Indian Construction is becoming more Technology aware, and if I might add \"actually keen\" to adopt it.",
            "I remember 3 years back clients would say that our Project Lifecycle Manager (PLM) solution will not get adopted by their SMALL contractors and suppliers. As of today, we have more than 25,000 contractors and suppliers onboarded and trained on PLM so that they can engage digitally with their larger clients ( RealEstate companies, PMCs, and GeneralContractors) for submitting quotations, raising RA bills, etc. Makes it extremely convenient to check Contract status at any time for both counterparties involved.",
            "So driving PLM adoption among contractors' and suppliers' ecosystem has undoubtedly become much easier."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7327985401619513346/"
    },
    {
        "num": 33,
        "date": "03 May 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Our leadership team at Bandhoo Solutions met to discuss operating plan for FY26. Ending with good filter coffee at an Udupi restaurant.",
            "We ended FY25 with 3X revenue growth and becoming Ebitda positive in the final quarter. FY26 goals include becoming full year PAT positive, and achieving large revenue growth.",
            "5 years of hard work, and God's support through a few critical lucky breaks has helped us get here. Hoping that luck continues to smile upon us (same as everyone's smile in this photo)"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7324304647660130304/"
    },
    {
        "num": 34,
        "date": "20 Apr 2025",
        "repost": false,
        "topic": "Manpower",
        "tags": [
            "ProjectDelivery",
            "ProjectManagement"
        ],
        "paras": [
            "Client COO: We really need a lot more construction manpower at our sites",
            "Me: We can solve this for you. We provide construction workers on staffing basis though. Not measurement basis.",
            "Client COO: But why not",
            "Me: Because we are not a Labour Contractor. We are a Staffing company.",
            "Client COO: What are your rates?",
            "Me: At your project location, it is XX for 9 hours for skilled workers and YY for 9 hours for unskilled helpers",
            "Client COO: But this seems high",
            "Me: This includes PF, Accommodation, Travel, PPE, Tools etc. So it is actually not high.",
            "Client COO: My Contractor also says this is high.",
            "Me: And that's the reason he is unable to meet your expectations of manpower. He is not paying suitable/ appropriate wages to the workers. And you will keep incurring your monthly overheads because of this shortage with more delay. On balance, which choice do you want to make?",
            "Some client COOs understand this trade-off and work with us. Some don't. Construction constructionworkers manpowershortage Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7319607613501886464/"
    },
    {
        "num": 35,
        "date": "14 Apr 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "FY25 was a great year in terms of new client adds for Bandhoo Solutions. This also led to 3X revenue growth for us in FY25. The visual below shows what happened.",
            "If you are a Real Estate company or a General Contractor, we would love to talk to you to solve your pain points with measurable cost savings and ROI.",
            "PS - It is noteworthy that we have practically no clients in metros like Hyderabad, Chennai, Kolkata and Ahmedabad. Lots of growth potential."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7317418716428713984/"
    },
    {
        "num": 36,
        "date": "01 Apr 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "March was an amazing month for Bandhoo Solutions, and JFM quarter revenues were 32% higher QoQ, setting new performance benchmarks for the business. We continue to add some of the biggest names as our clients in RealEstate and Construction. I get a feeling that we are at the right speed for takeoff now; and FY26 is when we will soar towards the sky!!!!",
            "Sridhar Sundaram, Gaurav Jajodia, Nikhilesh Dangayach, Noopur Arora, Sumanth J"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7312803488592183296/"
    },
    {
        "num": 37,
        "date": "28 Mar 2025",
        "repost": false,
        "topic": "Careers",
        "tags": [
            "Drones",
            "CONSTRA",
            "ProjectMonitoring",
            "LandSurvey"
        ],
        "paras": [
            "We (Bandhoo Solutions) are further expanding our CONSTRA business and hiring a couple of more DronePilots in metro locations - Bangalore, Mumbai, Gurgaon. If you are a Drone Pilot, or any of your friends are Drone Pilots, please ask them to send their profiles to us at info [at] bandhoo [dot] com"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7311333481274359808/"
    },
    {
        "num": 38,
        "date": "22 Mar 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "If you are a leader in a RealEstate or Construction company, make a list of problems that give you headaches and then explore which technology solutions can solve those. Easier said than done. I am sharing a list of very common problems faced by leaders in India, particularly due to the recent booming growth in RealEstate and Infrastructure. If one or more of these problems you face, talk to us at Bandhoo Solutions and we should be able to help you."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7309037645534310400/"
    },
    {
        "num": 39,
        "date": "20 Mar 2025",
        "repost": false,
        "topic": "Industry",
        "tags": [
            "",
            "RealEstate",
            "Construction",
            "ConstructionTech",
            "ConstructionWorkers"
        ],
        "paras": [
            "Gokul's thinking has been really distinctive and spot-on. We decided to build Bandhoo Solutions as a CompoundStartup about 3 years back and have made solid progress by adding a couple of Saas solutions to our marketplace solution.",
            "Now we serve almost all of India's large real estate companies, except a couple."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7308366877125226497/"
    },
    {
        "num": 40,
        "date": "18 Mar 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Sridhar Sundaram and I are glad to report that Bandhoo Solutions achieved its first-ever EBITDA positive (5% EBITDA margin) month in February, which happens to be our 61st month of operation (exactly 5 years and 1 month).",
            "We had told our investors that we will achieve breakeven by March 2025, so we did it 1 month ahead of that target.",
            "Goal now is to try to maintain this EBITDA positive in all the coming months despite the upcoming payroll hike in April.",
            "Thanks to all our clients who have given us the opportunity to build Bandhoo into India's leading ConstructionTech enterprise. And thanks to our key leaders in each line-of-business who have worked hard to deliver this milestone - Gaurav Jajodia, Nikhilesh Dangayach, Noopur Arora, Sumanth J"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7307625573349003264/"
    },
    {
        "num": 41,
        "date": "11 Mar 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "ConstructionTechnology",
            "Construction",
            "Infrastructure"
        ],
        "paras": [
            "Bandhoo Solutions - Our PLM solution delivers great ROI to large RealEstate companies and PMCs. However, not every client derives the same ROI. The main driver of the variation is executive sponsorship. I took 10 clients and mapped their executive sponsorship for PLM and the picture is quite telling. There is a strong correlation with the extent and strength of senior sponsorship. Surprisingly, many CEOs/ Promoters in the sector delegate Technology decisions and the implementation, which can be detrimental to capturing full ROI."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7305088620518932481/"
    },
    {
        "num": 42,
        "date": "04 Mar 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [],
        "paras": [
            "Delighted to see client leaders and managers wholeheartedly adopting our PLM (Project Lifecycle Manager) solution to derive full benefits in terms of ROI, efficiency, speed and control."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7302571504615993344/"
    },
    {
        "num": 43,
        "date": "26 Feb 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "ConstructionManpower"
        ],
        "paras": [
            "PMF - I am told one big signal of achieving PMF is a noticeable increase in inbound from potential customers. If that be the case, we seem to be approaching PMF for all the three service lines/ solutions we have. Leading RealEstate and Construction companies are beginning to appreciate the value of distinctive ConstructionTechnology. In recent months, we have added more marquee names as clients, e.g., Runwal Group, Hines, and Assetz",
            "Bandhoo Solutions | Procurement | ProjectMonitoring |"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7300384485152366592/"
    },
    {
        "num": 44,
        "date": "24 Feb 2025",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "IndianRailways is very crucial for the Construction sector, in a way that most people don't realize.",
            "Migrant constructionworkers use railways for all their travel. Two problems hurt them - availability of tickets and speed of travel. Both of these cause misery and troubles to them, and eventually their employers as well.",
            "Passenger Trains: As of recent reports, the average speed for passenger trains (excluding suburban services) was approximately 42.3 km/h between April and September 2023, down from 47.6 km/h the previous year.",
            "Express Trains: Mail and express trains have slightly higher speeds, averaging around 51.1 km/h as of 2023-24.",
            "Last 5 Years: The average speed of mail/express trains increased marginally from 50.6 km/h in 2019-20 to 51.1 km/h in 2023-24. Ordinary passenger trains saw a slight improvement from 33.5 km/h to 35.1 km/h during the same period.",
            "These speeds (35-50kmph) compare quite poorly with other countries. Most of the US trains deliver average speed of 70-100kmph. This unlocks the capacity to ply more trains, which in turn improves availability.",
            "I hope this (speeds and availability) gets more support and attention from GoI and the Railways Ministry."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7299676919891931136/"
    },
    {
        "num": 45,
        "date": "19 Feb 2025",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "L&T Chief, SNS, has been highlighting the manpower shortages at construction sites - a problem that's indeed very real and rampant. My thoughts on why this happens - particularly w.r.t. the contractual bindings that everyone in the sector is so used to.",
            "There is a way to reduce the shortages by changing the commercial model used by GCs and Project Owners. But it requires a different mindset and willingness to change and adopt something new."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7297869555232559105/"
    },
    {
        "num": 46,
        "date": "11 Feb 2025",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "If you are surveying your land parcels using Total Station and manual surveyors, it is time you tried out our Drone survey solution which is 8-10 times faster, more accurate and extremely convenient in terms of digital data for visualization and analytics. You can easily do up to 200 acres of land survey within a day, and processing of the data takes a few hours. RealEstate Construction Infrastructure Industrial Warehousing LogisticsParks Drones",
            "Check out the video below (Bandhoo Solutions)"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7294924238950477825/"
    },
    {
        "num": 47,
        "date": "10 Feb 2025",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "ConstructionTechnology",
            "Procurement"
        ],
        "paras": [
            "The annual budgets and operating plans are being made for FY26, and everyone is looking for cost saving and profit enhancement ideas. If you are in RealEstate or Construction, then you should seriously evaluate our Project LifeCycle Manager solution which can deliver fantastic ROI within 12 months and on a sustainable basis thereafter.",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7294679493862899713/"
    },
    {
        "num": 48,
        "date": "05 Feb 2025",
        "repost": true,
        "topic": "Careers",
        "tags": [],
        "paras": [
            "🚧 We're Hiring: Construction Analyst 🏗️",
            "Are you passionate about construction, site inspections, and project management? Do you have an eye for detail and a knack for AutoCAD, MEP, and civil works? If so, we want YOU on our team!",
            "Role Overview:",
            "🔹 Work on AutoCAD drawings and assist in project planning.",
            "🔹 Conduct site inspections (flats/villas) and take precise measurements.",
            "🔹 Monitor MEP works (electrical, plumbing, HVAC, firefighting, etc.).",
            "🔹 Prepare progress reports and ensure timely project updates.",
            "What We’re Looking For:",
            "✔️ Degree in Civil/Mechanical/Electrical Engineering or related fields.",
            "✔️ 1.5–3 years of experience in civil, MEP, or interior works.",
            "✔️ Prior site engineering experience preferred.",
            "✔️ Knowledge of structural, finishing, and MEP works.",
            "✔️ Solar project experience is a plus!",
            "✔️ Strong communication skills & proficiency in office tools.",
            "📩 To Apply: Send your resume to sumanth.j@bandhoo.com and jiljith.joseph@bandhoo.com",
            "Know someone perfect for this role? Tag them below!3"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7292907700282109953/"
    },
    {
        "num": 49,
        "date": "25 Jan 2025",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "Lodha group has a really special place in our journey at Bandhoo Solutions. It has been an incredible journey to serve them on their Technology needs and also learn from them in the process.",
            "Delighted to see their continued growth and success - new markets, margin expansion, rapid digitization and transformation, etc.",
            "Macrotech Developers Q3: Net profit increases 66% YoY, revenues and bookings increase"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7288964824670056448/"
    },
    {
        "num": 50,
        "date": "24 Jan 2025",
        "repost": false,
        "topic": "Careers",
        "tags": [
            "RealEstate",
            "CivilEngineer",
            "CivilEngineering",
            "Billings",
            "WorkCertification"
        ],
        "paras": [
            "URGENT:",
            "Looking to hire a Civil Engineer who has 3-4 years of experience in certifying work done at construction sites. Please tag/refer your friends. Terrific opportunity to join the bandwagon of building a unique AI-based Tech product that works in the Indian context.",
            "Send CV to info [at] bandhoo [dot] com and Sumanth [dot] j [at] bandhoo [dot] com"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7288499790873563136/"
    },
    {
        "num": 51,
        "date": "18 Jan 2025",
        "repost": false,
        "topic": "Company",
        "tags": [
            "Construction",
            "ConstructionTechnology",
            "RealEstate"
        ],
        "paras": [
            "Bandhoo Solutions was incorporated exactly 5 years ago on 17th January 2020. We have now got through 20 quarters. The chart below shows our Indexed Revenues (indexed to 1 from our 3rd quarter).",
            "Covid waves - 1st and 2nd - ensured that we had limited growth for about 7 quarters. That was the most testing period for us when we just couldn't do anything at all. And almost every day we would ask ourselves whether we should continue or abandon ship. The journey from 8th quarter onwards has been much better.",
            "This 5-year period is also my longest stint in any one role. Otherwise, my roles have changed every 2-3 years.",
            "Thanks to everyone - fellow Bandhoo colleagues, clients, and partners who have helped get Bandhoo to where it is today."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7286293535404765184/"
    },
    {
        "num": 52,
        "date": "03 Jan 2025",
        "repost": false,
        "topic": "Careers",
        "tags": [
            "RealEstate",
            "Construction"
        ],
        "paras": [
            "Hyderabad - BusinessDevelopment opportunity for people with existing relationships in the Real Estate and Construction sector in Hyderabad. Attractive compensation. Profile - ex employee of IPCs/ PMCs with an appetite for networking and sales with a minimum of 10 years experience. Please refer by sending an email to prashant.gupta@bandhoo.com",
            "Bandhoo Solutions,"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7280832344205225985/"
    },
    {
        "num": 53,
        "date": "17 Dec 2024",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "Is it good to force PF deductions and contributions?",
            "This is a question I have grappled with for some time now. In our work with thousands of constructionworkers, it is clear that there is a LARGE SEGMENT of workers who consider PF as highly undesirable. They refuse to work for any employer who does PF deductions and contributions. They would rather work for a small contractor who pays them everything in cash.",
            "These are bottom-of-the-pyramid guys, and I can understand why they want to maximize their current income instead of contributing to something futuristic.",
            "The corollary is that many employers don't formalize employment and keep paying workers in cash, or as interns because that's like a win-win, surprisingly. Workers are happy and employer has lower cost.",
            "So should PF be mandatory at all? Is there a different way to think about the objectives of formalized employment? Thoughts?"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7274650344297545728/"
    },
    {
        "num": 54,
        "date": "15 Dec 2024",
        "repost": false,
        "topic": "Company",
        "tags": [
            "ConstructionTech",
            "RealEstate",
            "StartupJourney"
        ],
        "paras": [
            "2024 has been another bittersweet year for Bandhoo Solutions – some wins and some losses. Let me share some of those (my top-of-mind list).",
            "The good:",
            "1.     We closed a small funding round in January, thanks to the support of Venture Catalysts++ | India's 1st Multi-Stage VC and a handful of really close friends, who opened their purses very liberally. Nearly Rs 3.5cr has come from a small group of friends and family thus far, for which I am eternally grateful (Manish Gupta, Neeraj Aggarwal, Srini Sriniwasan, Prashant Malik, Vikram Kapur, Amit Khera, Abhishek Kumar)",
            "2.     We grew 3X YoY in revenues terms, and we hit two milestones in terms of scale – USD 1mn ARR and USD 2mn ARR. We have spent USD 2mn so far in building Bandhoo, so we feel good about our capital efficiency.",
            "3.     We acquired another business – CONSTRA – to add AI-based Visual intelligence platform for land surveys and project monitoring using drones and 360-degree captures",
            "4.     We landed some big name as new clients, e.g., Godrej Properties, Adarsh Group, Brigade, Brookfield, etc.",
            "5.     Our social impact has been good during the year, providing more than 50,000 man-days worth of work to construction workers. Ensuring timely and fair wages to them is genuinely fulfilling.",
            "The not-so-good:",
            "1.     We had to take legal action to recover dues from a large brand company (more than 100 years old legacy). Small amount of money for them but important enough for us.",
            "2.     We didn’t convert some of the very promising large brand names into customers despite multiple discussions and a very clear value proposition. We don’t know why they didn’t sign up because there is now radio silence.",
            "3.     Three friends reached out to seek PLM demos and proposals for their respective companies. And I was very confident that these will definitely convert. Didn’t happen. Maybe in 2025.",
            "4.     The CONSTRA acquisition gave us a few negative surprises. It has been more challenging to integrate and achieve the outcomes we had planned for.",
            "The roller-coaster of the startup life continues. The list above looks a bit balanced now compared to 2020, 2021, 2022 and 2023. Still a lot of hard work to do - to have more wins than losses."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7273935245605838848/"
    },
    {
        "num": 55,
        "date": "27 Nov 2024",
        "repost": false,
        "topic": "Careers",
        "tags": [
            "HumanResources",
            "HR",
            "Startups",
            "HRGeneralist"
        ],
        "paras": [
            "If you are a HR Generalist, about 30yrs old, with startup experience, and dealt with SDE talent, looking for the next exciting gig for yourself, then I want to talk to you.",
            "Please send your profile to info@bandhoo.com"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7267438968219013120/"
    },
    {
        "num": 56,
        "date": "19 Nov 2024",
        "repost": false,
        "topic": "Careers",
        "tags": [],
        "paras": [
            "ALERT: We are adding to our Engineering team. Java and mySQL knowledge is crucial.",
            "1. SDE 1 (Backend) - 2 Positions (0-2 years experience).",
            "2. SDE 1 (Frontend) - 2 Positions (0-2 years experience)",
            "If you have any suggestions or referrals, kindly share it with Noopur Arora",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7264662569355747328/"
    },
    {
        "num": 57,
        "date": "19 Nov 2024",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "Very interesting report on rising CostofConstruction by Colliers providing data that corroborates what we are seeing in our business.",
            "Largest spike is in Labour cost. 150% over 5 years. This will keep increasing for two reasons - (a) Project overheads in companies are sharply rising, and (b) Manpower shortages are causing higher wages to be paid for skilled workers",
            "Bandhoo Solutions is right in the center of this (r)evolution through our Saas and marketplace solutions where we solve for digitization using Saas offerings (ensuring higher productivity within a company) and reduce manpower shortages using our innovative marketplaces."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7264551821136797697/"
    },
    {
        "num": 58,
        "date": "17 Nov 2024",
        "repost": false,
        "topic": "Company",
        "tags": [],
        "paras": [
            "So what does it mean to be a CEO?",
            "I have completed 10 years of being CEO, starting with abof in 2014, then moving to Emaar in 2018, and then Bandhoo since 2020. The diversity has been tremendous across these stints as is evident from the table below that captures a handful of dimensions of the role. So what's common in my view - lots of responsibility - everyone looks up to you for solutions, direction, guidance, help, etc. Also, many gut-punches that you have to take in your stride.",
            "The biggest help you have is from your team. External people (e.g., consultants, bankers, lawyers) can help you a bit but not that much. It finally boils down to your co-passengers in the journey - across all levels of the company."
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7263926159296339968/"
    },
    {
        "num": 59,
        "date": "07 Nov 2024",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "Moving away from using spreadsheets and WhatsApps for Construction Progress Monitoring is very hard - mostly because Apps/solutions require lots of manual entries to be done by the site teams. NOT ANYMORE!!",
            "Our CONSTRA solution makes it extremely easy with no/minimal data entry by site teams. CONSTRA combines the power of drones and 360-cameras along with AI/Computer Vision to make progress monitoring effortless. Imagine having a time machine on your laptop that provides accurate and timely progress update of what's happening in every nook-and-corner of any site - and that too without asking the site team for anything.",
            "Companies in USA are already using this at scale, and Indian companies are now lining up to adopt this too. If you want to know more, write to us on info@bandhoo.com",
            "Check this 1-min video: [link] RealEstate GeneralContractors Construction ProgressMonitoring",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7260191491891814400/"
    },
    {
        "num": 60,
        "date": "04 Nov 2024",
        "repost": false,
        "topic": "PLM",
        "tags": [
            "RealEstate",
            "Construction",
            "GeneralContractor",
            "CapitalExpenditure",
            "Procurement",
            "RABillings"
        ],
        "paras": [
            "Our PLM (Project Lifecycle Manager) has some stunning statistics of usage now - and it indisputably demolishes any concerns about the ability of the ecosystem to adopt technology.",
            "Cost budgets configured by users on PLM - nearly Rs 100,000cr (cumulative);",
            "Hundreds of tenders/RFQs floated every month;",
            "Thousands of bids from vendors/suppliers received every month",
            "If you are a leader at a Real Estate company, a PMC, a General Contractor, or anyone dealing with large value of CapEx projects (e.g., in Manufacturing, Hospitality), look at PLM very closely and try it out.",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7259175352982208512/"
    },
    {
        "num": 61,
        "date": "31 Oct 2024",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "Do all migrant construction workers go back home during Diwali?",
            "No. We have a few operational sites in North India where a few hundred construction workers (across civil, MEP, Finishing) are helping our clients complete their projects. About half the workers have gone back to their hometown for celebrating Diwali while remaining have chosen to stick around at the project site.",
            "We gave them some sweets and candles to help them celebrate Diwali at the project site itself. RealEstate ConstructionWorkers GeneralContractors ConstructionWorkers Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7257626651390291968/"
    },
    {
        "num": 62,
        "date": "26 Oct 2024",
        "repost": false,
        "topic": "PLM",
        "tags": [],
        "paras": [
            "This is the impact of our Saas solution once implemented. Compelling? RealEstate Construction DigitalTransformation Procurement Billings",
            "Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7255812803607896064/"
    },
    {
        "num": 63,
        "date": "16 Oct 2024",
        "repost": false,
        "topic": "Manpower",
        "tags": [],
        "paras": [
            "Lodha Group/ Lodhais an amazing juggernaut.",
            "I spent most of my day yesterday with some of their leaders. It always amazes me as to how eager and how clear they are about adopting technology that helps them drive operational efficiency. They are planning a huge ramp-up of operations and they want to avoid adding proportionate manpower - only technology can solve this.",
            "For instance, their attitude towards Contractors and timeliness of payments to them is refreshingly different from the norm. They are already the very best in this but want to become even better. What we are doing with them jointly is going to redefine this business process and establish new benchmarks. Excited to partner with them on this fantabulous journey.",
            "Nikhilesh Dangayach | Noopur Arora | Sridhar Sundaram RealEstate ConstructionTechnology Bandhoo Solutions"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7252205828118622208/"
    },
    {
        "num": 64,
        "date": "04 Oct 2024",
        "repost": false,
        "topic": "CONSTRA",
        "tags": [],
        "paras": [
            "Creating DigitalTwins is the new norm for Infrastructure, buildings, warehouses, etc. India's leading RealEstate companies are taking note of this to monitor the project sites and Construction progress very accurately and conveniently.",
            "A terrific use of AI based technology that is rapidly becoming the norm. Adoption is extremely easy. If you oversee or manage Construction Projects in India, this technology is available to you at very affordable cost.",
            "Talk to Bandhoo Solutions about CONSTRA.",
            "Create ‘digital twin’ to address Bengaluru's traffic woes: former Infosys CFO Mohandas Pai [link]"
        ],
        "url": "https://www.linkedin.com/feed/update/urn:li:activity:7247867609302413312/"
    }
]

export const blogArticles = [
    {
        "num": 1,
        "title": "Using Reverse Auction in Real Estate and Construction",
        "published": "September 3, 2024",
        "tags": [
            "RealEstate",
            "Construction",
            "Procurement",
            "Contracting"
        ],
        "body": [
            "In our client discussions, we are surprised how low is the usage of Reverse Auctions in Procurement departments of Real Estate and Construction companies. We offer a comprehensive Procurment Digitization solution through our PLM (Project Lifecycle Manager) offering, including Reverse Auctions.",
            "Based on actual client usage over the last couple of years, we can confidently assert that if you are not using Reverse Auction smartly in your Procurement you are leaving a lot of money on the table and foregoing profits. It could easily be Rs 1-2 lakhs per day (depends on the quantum of your procurement expenditure)",
            "Here are some basic facts to keep in mind based on real data from our own system.",
            "Fact 1 - Reverse Auctions can be used for any kind of Tender/ RFQ - Civil, MEP, Finishing, Others",
            "Fact 2 - It is not just Materials, you can procure Works items also through Reverse Auction",
            "Fact 3 - Savings can be sizeable, 10-15% on several items is the median savings achieved. For items like Steel, Cement, RMC, the savings are 1-5% but there are many items where savings are quite sizeable",
            "I hope these facts help you think more carefully about Procurement's digitization, and you are sufficiently tempted to explore the adoption of Reverse Auction for saving Rs 1-2 lakhs per day in your organization.",
            "Contact us @ Bandhoo Solutions for knowing more."
        ],
        "url": "https://www.linkedin.com/pulse/using-reverse-auction-real-estate-construction-prashant-gupta-ogxde/"
    },
    {
        "num": 2,
        "title": "Bandhoo: A Friend Of Contractors",
        "published": "August 2, 2023",
        "tags": [],
        "body": [
            "Construction contractors, particularly in India, have a difficult business to run. Every day there are several issues that come up that they need to solve and there is no ready agency to help them. Not anymore. Bandhoo is here to help with most of the day-to-day issues that you face.",
            "Most contractors focus a lot on cost and try to keep a lid on that. Unfortunately, in the process, they compromise on the TIME dimension of projects, which is so critical. In fact, if contractors were to optimize for TIME and ensure that the Project is happening extremely fast everyday, it will automatically ensure much lower costs than what might have been estimated or budgeted. Bandhoo helps you save cost and time in all your projects.",
            "Bandhoo uses its expert team and proprietary technology to solve most of the critical issues that a Contractor faces:",
            "Buying Category B items: Everyone in the industry has strong capability to buy large spends - cement, RMC, steel, and aggregates. The struggle happens when you are buying the other items that are Category B/C. Too much time of the Procurement teams go into getting the right quotes for such requirements. We use our proprietary database to get such quotes very quickly (within 3 days) and ensure that you don't overspend on such items. Think of us as ONE-STOP-SHOP for all your material purchases.",
            "Finding high-quality subcontractors: We have helped many clients find good quality SME contractors for executing turnkey works of all kinds - be it Overhead tanks, residential buildings, Metro pillars, office buildings, Waterproofing works, Firefighting works, Expansion joint works, etc.",
            "Finding high-quality small labour-contractors: We service hundreds of such demand every month where our clients ask us to find all kinds of labour-contractors who can take up works on item-rate basis. For example, Flooring works at Rs 15-25/sqft, Stonework at Rs 35-50/sqft, Plastering works at Rs 10-20/sqft, Shuttering works at Rs 150-250/sqm, Barbending works at Rs 5000-7000/ton. Similarly for excavation, Concreting, scaffolding, Painting, Plumbing, Electrical, etc. We have 80,000 of these small contractors associated with us spread across India and typically we are able to find good guys within 5-10 days",
            "Mobilizing workers: Wages have shot up in the recent past. Skilled workers are now commanding Rs 1000-1200/day including overtime and unskilled workers are getting Rs 600-700/day. We help clients find workers for their project sites. In selected cases, we also run the labour payroll through our own system. Our pool of more than 225,000 workers (and steadily growing every month) makes it more likely that you will find workers for your requirements through our App.",
            "Remotely monitoring progress of projects: This is one of the hidden gems in our portfolio of solutions. You can set up any kind of construction project (large building, highway/ bridge, interiors of an apartment, independent villa, handover checklist), add multiple users with good access control and specific rights, and monitor progress sitting in your office in the HQ without visiting the site.",
            "We have made tremendous progress in the last 4 years to build all of these solutions, expand our network, sign up and serve some of the biggest and most marquee names in the Construction industry in India. If you haven't spoken to us yet, please reach out and we will be happy to explain how we can truly help you reduce cost and time in your projects.",
            "Write to us on info@bandhoo.com or call our helpline +91-6364-432-123"
        ],
        "url": "https://www.linkedin.com/pulse/bandhoo-friend-contractors-prashant-gupta/"
    },
    {
        "num": 3,
        "title": "Mobilizing Construction Site Quickly",
        "published": "October 22, 2022",
        "tags": [
            "Construction",
            "India",
            "Technology",
            "CivilInfrastructure",
            "MEP",
            "Finishing",
            "Infrastructure",
            "RealEstate"
        ],
        "body": [
            "If your Construction Project is suffering delays due to manpower shortage, then read on.....",
            "Most real estate developers in India appoint PMCs and General Contractors for executing their Projects in the hope that their projects will happen in a timely manner, within budgeted costs, and good quality. They focus on drafting the contractual terms with suitable penalties and incentives to make this happen. However, this doesn't play out that well in several cases because the contract cannot make up for lack of capabilities.",
            "Project Managers and Site Engineers go through a lot of pain trying to ensure right quantity and quality of small contractors and workers at their project sites. They spend most of their time chasing these resources - through phone calls and WhatsApp - because they have budgetary constraints that are often unreasonable.",
            "RERA has ensured that several aspects of the projects are clearly defined and worked out before construction starts, e.g., land availability and all govt approvals being in place. Therefore, the main reason nowadays that projects get delayed are two:",
            "Insufficient construction manpower at site",
            "Insufficient cash to pay contractors and suppliers",
            "Cash is the lifeblood of any project. If not funded properly, it leads to delays, largely because both - material suppliers and labour contractors delay their works if payments to them are not timely. This article doesn't deal with how to manage cashflows. But on the topic of insufficient construction manpower, there is now a proven solution for Developers, GCs and PMCs to consider - Bandhoo's platform for construction site mobilization.",
            "What can Developers do? Bring in Bandhoo as a collaboration partner to supplement the efforts of the GC/ PMC. Bandhoo provides a robust tech-enabled mechanism to reach out to thousands of SME contractors and lakhs of workers to find those who are available and willing to work at your project's location.",
            "What can GC/ PMCs do? Get the Project Managers to adopt Bandhoo's solution and post suitable tenders and jobs on the platform to access thousands of SME contractors and lakhs of workers. It is an App based solution so all that you need is your smartphone. Download the App, register the company and its users and you can get going.",
            "Bandhoo covers all the construction trades for all kinds of construction projects - RCC, masonry, shuttering, barbending, fabrication, welding, electrical, plumbing, flooring, stonework, scaffolding, painting, excavation and earthworks, etc. Bandhoo has already served demand in more than 150 districts of India for projects as diverse as Residential buildings, Commercial offices, Clubhouses, Highways, Bridges, Railways, Tunnels, Airports, Hospitals, Schools, etc.",
            "So what benefits can you expect if you use Bandhoo? 30-50% reduction in time taken to mobilize or scale-up construction manpower at your project site. And 100% staffing at site (assuming you have the right level of rates and wages being offered)"
        ],
        "url": "https://www.linkedin.com/pulse/mobilizing-construction-site-quickly-prashant-gupta/"
    },
    {
        "num": 4,
        "title": "How To Save Cost and Time in Construction Projects in India?",
        "published": "January 15, 2022",
        "tags": [],
        "body": [
            "In India, #Construction projects are almost never on time, often have poor quality, and suffer from regularly escalating costs. A big part of this problem is very low digital adoption and archaic processes about how things get done. As MGI report from 2015 shows, the Construction sector globally (not just in India) has one of the lowest digitization index. See picture below",
            "(Source: [link]",
            "If you are running any kind of Capex program or project, and are frustrated with today's processes and approach, and excited about making things dramatically better, read on!! The table below shows what's possible.",
            "All of this is doable! But you need really serious commitment from the leadership team at the very top because it is a digital transformation agenda. Resistance to change will be tremendous, and getting this done will have its pain, but there is big pot of Gold at the other side of this pain.",
            "How can this happen? What will be take?",
            "We at Bandhoo Solutions are working hard to convince clients in Real Estate, Infrastructure and Construction to adopt digital solutions for making their businesses and operations better. We already have a suite of solutions that can be easily deployed for easy interaction across companies (e.g., the C&P team in a developer and Bidding team in a contractor) and within a company. These modern technology tools are simple and effective.",
            "We can see the signs of adoption. There are pockets of like-minded business owners and professionals who are beginning to see the inevitability of making this digital shift. This is a small pool as of now but is steadily increasing. And the time is not far when we will see a deluge of adoption of digital platforms in Construction too. That inflection point is maybe 2-3 years away, but it is definitely coming. Like in a roller-coaster ride, one can see what's ahead, and it is exhilarating!!!",
            "If you would like to know more, please reach out to me at prashant.gupta@bandhoo.com"
        ],
        "url": "https://www.linkedin.com/pulse/how-save-cost-time-construction-projects-india-prashant-gupta/"
    }
]
